import { graphqlFetch } from '@/utils/graphqlFetch';
import { ClassOutput, ClassQuery } from '../gql/graphql';
import { GET_CLASSES } from '../queries';
import { useQuery } from '@tanstack/react-query';

export const useGetClasses = (query: ClassQuery) => {
  return useQuery<ClassOutput[], Error>({
    queryKey: ['getClasses', query],
    queryFn: async () => {
      const data = await graphqlFetch<
        { getClasses: ClassOutput[] },
        { query: ClassQuery }
      >(GET_CLASSES, { query });
      return data.getClasses;
    },
    enabled: !!query,
  });
};
